import { render, staticRenderFns } from "./ApprovePlanModal.vue?vue&type=template&id=40d6f734&scoped=true&"
import script from "./ApprovePlanModal.vue?vue&type=script&lang=js&"
export * from "./ApprovePlanModal.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePlanModal.vue?vue&type=style&index=0&id=40d6f734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6f734",
  null
  
)

export default component.exports